<script>
import BaseLoading from "@/components/CustomComponent/shared/Loading.vue";
import { useSharedStore } from "@/stores/shared-store";
import { useExamFetchStore } from "@/stores/exam/exam-fetch-store";

export default {
  components: {
    BaseLoading,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 5,
    };
  },
  computed: {
    sharedStore() {
      return useSharedStore();
    },
    examFetchStore() {
      return useExamFetchStore();
    },
    totalPages() {
      return Math.ceil(
        this.examFetchStore.myExamSubmission.length / this.perPage
      );
    },
    paginatedSubmissions() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.examFetchStore.myExamSubmission.slice(start, end);
    },
  },
  mounted() {
    this.examFetchStore.fetchExamSubmissionsListBySelf();
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
  },
};
</script>

<template>
  <layouts-header></layouts-header>
  <!-- Breadcrumb -->
  <div class="breadcrumb-bar text-center">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12">
          <h2 class="breadcrumb-title mb-2">My Exam Attempts</h2>
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb justify-content-center mb-0">
              <li class="breadcrumb-item">
                <router-link to="/home">Home</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                My Exam Attempts
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <!-- /Breadcrumb -->

  <div class="content">
    <div class="container">
      <!-- profile box -->
      <student-header></student-header>
      <!-- profile box -->
      <div class="row">
        <!-- sidebar -->
        <student-sidebar></student-sidebar>
        <!-- sidebar -->
        <div class="col-lg-9">
          <div
            class="page-title d-flex align-items-center justify-content-between"
          >
            <h5>My Exam Attempts</h5>
          </div>

          <div
            v-if="examFetchStore.myExamSubmission.length === 0"
            class="text-center p-5 bg-light border rounded mb-3"
          >
            <h5 class="mb-2">Belum ada attempt exam</h5>
            <p class="mb-0 text-muted">
              Hasil exam yang sudah dikerjakan akan muncul di sini.
            </p>
          </div>

          <template v-else>
            <div
              class="d-flex align-items-center justify-content-between border p-3 mb-3 rounded-2"
              v-for="(item, index) in paginatedSubmissions"
              :key="item.submissionID || index"
            >
              <div>
                <h6 class="mb-1">
                  <router-link
                    :to="`/students/student-exam-detail/${item.submissionID}`"
                    >{{ item.course_title }}</router-link
                  >
                </h6>
                <p class="fs-14">Number of Attempts : {{ item.attempt }}</p>
              </div>
              <div>
                <router-link
                  :to="`/students/student-exam-detail/${item.submissionID}`"
                  class="arrow-next"
                  ><i class="isax isax-arrow-right-1"></i
                ></router-link>
              </div>
            </div>
            <!-- /pagination -->
            <div class="row align-items-center mt-3" v-if="totalPages > 1">
              <div class="col-md-2">
                <p class="pagination-text">
                  Page {{ currentPage }} of {{ totalPages }}
                </p>
              </div>
              <div class="col-md-10">
                <ul
                  class="pagination lms-page justify-content-center justify-content-md-end mt-2 mt-md-0"
                >
                  <li
                    class="page-item prev"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      tabindex="-1"
                      @click="goToPage(currentPage - 1)"
                      ><i class="fas fa-angle-left"></i
                    ></a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in totalPages"
                    :key="page"
                    :class="{ active: currentPage === page }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="goToPage(page)"
                    >
                      {{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item next"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="javascript:void(0)"
                      @click="goToPage(currentPage + 1)"
                      ><i class="fas fa-angle-right"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- /pagination -->
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <!-- <footer-two></footer-two> -->
  <!-- /Footer -->
  <BaseLoading v-show="sharedStore.loading"></BaseLoading>
</template>
